import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Spin } from "antd";
import toast from "react-hot-toast";
import OtpInput from "react-otp-input";
import { generateOtp, verifyOtp } from "../../modules/auth/services/otpApi";
import Lottie from "lottie-react";
import mailAnim from "../../assets/animations/mailAnimation.json";
import "./style.css";

const OTPCodeVerify = ({ isOpen, title = "Confirmation", message = "Un code vous a été envoyé.", onCancel, onVerified }) => {
  
  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const email = currentUser?.email;
  // const email = "bayecheikh.fall@systalink.fr"
  
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setStep(1);
      setOtp("");
      setVerified(false);
      setCountdown(0);
    }else {
      setStep(1);
      setOtp("");
      setVerified(false);
      setCountdown(0);
    }
  }, [isOpen]);

  const handleGenerateOtp = async () => {
    setLoading(true);
    try {
      await generateOtp(email);
      toast.success("Code envoyé à votre adresse email.");
      setStep(2);
      setCountdown(300);
    } catch (err) {
      toast.error("Erreur d'envoi, veuillez actualiser ou contacter le support");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let interval;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [countdown]);

  const formatTime = (sec) => {
    const min = Math.floor(sec / 60).toString().padStart(2, "0");
    const secRemain = (sec % 60).toString().padStart(2, "0");
    return `${min}:${secRemain}`;
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      toast.error("Le code doit contenir 6 chiffres");
      return;
    }

    setLoading(true);
    try {
      const response = await verifyOtp(email, otp);
      if (typeof response === "string" && response.toLowerCase().includes("otp vérifié")) {
        toast.success("Code vérifié avec succes");
        setVerified(true);
        setTimeout(() => {
          onVerified();
        }, 200);
      } else {
        toast.error("Code incorrect");
      }
    } catch (err) {
      toast.error("Erreur de vérification");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered backdrop="static">
      <ModalHeader toggle={onCancel}>
        <strong>{title}</strong>
      </ModalHeader>

      <ModalBody className="text-center">
        <div style={{ maxWidth: 150, margin: "0 auto" }}>
          <Lottie animationData={mailAnim} loop={false} />
        </div>

        {step === 1 && (
          <>
            <p className="mt-3">{message}</p>
            <p>Souhaitez-vous continuer ?</p>
          </>
        )}

        {step === 2 && (
          <>
            <p>Saisissez le code reçu :</p>
            <div className="otp-container">
            <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderInput={(props) => (
                    <input
                    {...props}
                    className="otp-input"
                    />
                )}
            />
            </div>

            <div className={`otp-timer ${countdown <= 60 ? "red" : "default"}`}>
              ⏳ Le code expire dans : <strong>{formatTime(countdown)}</strong>
            </div>

            {countdown === 0 && (
              <div className="text-danger small mt-2">
                Le code a expiré. Cliquez sur 
                <Button type="button" color="primary" onClick={handleGenerateOtp} disabled={loading}> Renvoyer le code </Button>
                pour en générer un nouveau.
              </div>
            )}
          </>
        )}
      </ModalBody>

      <ModalFooter className="d-flex justify-content-center">
        <Button type="button" color="secondary" onClick={onCancel} disabled={loading}>
          Annuler
        </Button>

        {step === 1 && (
          <Button type="button" color="primary" onClick={handleGenerateOtp} disabled={loading}>
            {loading ? <Spin size="small" /> : "Recevoir le code"}
          </Button>
        )}

        {step === 2 && !verified && (
          <Button
            type="button"
            color="primary"
            onClick={handleVerifyOtp}
            disabled={loading || countdown === 0}
          >
            {loading ? <Spin size="small" /> : countdown === 0 ? "Code expiré" : "Valider le code"}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default OTPCodeVerify;
